import { ReactComponent as Icon } from '../../assets/icons/payment.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
